import { createSlice } from '@reduxjs/toolkit';

const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState: {
    userInfo: {},
    isKnoxEnv: true,
    isKnoxEnvValueLoaded: false,
    roles: {},
    disasterMode: null,
  },
  reducers: {
    getUserInfo: () => {},
    getUserInfoSuccess: (state, { payload: userInfo }) => {
      state.userInfo = userInfo;
    },
    getRoles: () => {},
    getRolesSuccess: (state, { payload: roles }) => {
      state.roles = roles;
    },
    getDisasterRecoveryMode: () => {},
    getDisasterRecoveryModeSuccess: (state, { payload }) => {
      state.disasterMode = payload === 'Y';
    },
    getNoSessionDisasterRecoveryMode: () => {},
    getNoSessionDisasterRecoveryModeSuccess: (state, { payload }) => {
      state.disasterMode = payload === 'Y';
    },
    setIsKnoxEnv: (state, { payload }) => {
      state.isKnoxEnv = payload;
      state.isKnoxEnvValueLoaded = true;
    },
  },
});

export const {
  getUserInfo,
  getUserInfoSuccess,
  getRoles,
  getRolesSuccess,
  getDisasterRecoveryMode,
  getDisasterRecoveryModeSuccess,
  getNoSessionDisasterRecoveryMode,
  getNoSessionDisasterRecoveryModeSuccess,
  setIsKnoxEnv,
} = userInfoSlice.actions;
export default userInfoSlice.reducer;
